module.exports = __webpack_public_path__ + "media/images/logo-c42-m-ff783be5df2b839e9035a45ea29eef24.png";